import { render, staticRenderFns } from "./PortfolioTech.vue?vue&type=template&id=21924d6b&"
import script from "./PortfolioTech.vue?vue&type=script&lang=js&"
export * from "./PortfolioTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports